module.exports = __webpack_public_path__ + "img/s7bLogo1.00b6e360.svg";